import { type RouteRecordRaw } from "vue-router"

import { type Permission } from "@/types"
import { FunctionalRole } from "@/graphql/types"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/beitragsarten",
    name: "FeeTypePage",
    component: () => import("./feetypes/FeeTypePage.vue"),
    meta: {
      requiredRoles: <Permission[]>["fee:list", "fee:unlock"],
    },
  },
  {
    path: "/beitragsart/erstellen",
    name: "FeeTypeViewCreate",
    component: () => import("./feetypes/FeeTypeView.vue"),
    meta: {
      requiredRoles: <Permission[]>["fee:create", "fee:unlock"],
    },
    children: [
      {
        path: "",
        name: "FeeTypeFormCreate",
        component: () => import("./feetypes/FeeTypeForm.vue"),
      },
    ],
  },
  {
    path: "/beitragsart/:id/:selected?",
    name: "FeeTypeViewEdit",
    component: () => import("./feetypes/FeeTypeView.vue"),
    meta: {
      requiredRoles: <Permission[]>["fee:view", "fee:unlock"],
    },
    children: [
      {
        path: "",
        name: "FeeTypeFormEdit",
        component: () => import("./feetypes/FeeTypeForm.vue"),
      },
    ],
  },
  {
    path: "/beitragsschemen",
    name: "AccountingGroupPage",
    component: () => import("./accountingGroup/AccountingGroupPage.vue"),
    meta: {
      requiredRoles: <Permission[]>["fee:list", "fee:unlock"],
    },
  },
  {
    path: "/beitragsschema/erstellen",
    name: "AccountingGroupViewCreate",
    component: () => import("./accountingGroup/AccountingGroupView.vue"),
    meta: { requiredRoles: <Permission[]>["fee:create", "fee:unlock"] },
    children: [
      {
        path: "",
        name: "AccountingGroupFormCreate",
        component: () => import("./accountingGroup/AccountingGroupForm.vue"),
      },
    ],
  },
  {
    path: "/beitragsschema/:id",
    name: "AccountingGroupViewEdit",
    component: () => import("./accountingGroup/AccountingGroupView.vue"),
    meta: {
      requiredRoles: <Permission[]>["fee:view", "fee:unlock"],
    },
    children: [
      {
        path: "",
        name: "AccountingGroupFormEdit",
        component: () => import("./accountingGroup/AccountingGroupForm.vue"),
      },
    ],
  },
  {
    path: "/beitragsvorlagen",
    name: "FeeDraftPage",
    component: () => import("./feeDrafts/FeeDraftPage.vue"),
    meta: { requiredRoles: <Permission[]>["fee:list", "fee:unlock"] },
  },
  {
    path: "/beitragsvorlagen/erstellen",
    name: "FeeDraftViewCreate",
    component: () => import("./feeDrafts/FeeDraftView.vue"),
    meta: { requiredRoles: <Permission[]>["fee:create", "fee:unlock"] },
    children: [
      {
        path: "",
        name: "FeeDraftFormCreate",
        component: () => import("./feeDrafts/FeeDraftForm.vue"),
      },
    ],
  },
  {
    path: "/beitragsvorlagen/:id",
    name: "FeeDraftViewEdit",
    component: () => import("./feeDrafts/FeeDraftView.vue"),
    meta: { requiredRoles: <Permission[]>["fee:view", "fee:unlock"] },
    children: [
      {
        path: "",
        name: "FeeDraftFormEdit",
        component: () => import("./feeDrafts/FeeDraftForm.vue"),
      },
    ],
  },
  {
    path: "/beitragserhebung",
    name: "AccountingRunPage",
    component: () => import("./accountingRun/AccountingRunPage.vue"),
    meta: { requiredRoles: <Permission[]>[FunctionalRole.AccountingRun] },
    children: [],
  },
  {
    path: "/beitragsanalyse",
    name: "AnnualFeeOverviewPage",
    component: () => import("./annual/AnnualFeeOverviewPage.vue"),
  },
  {
    path: "/sepa-mandate",
    name: "SepaMandatesPage",
    component: () => import("./sepa/SepaMandatesPage.vue"),
    children: [
      {
        path: "sepa-mandate/:id",
        name: "SepaMandateDialog",
        component: () => import("./sepa/SepaMandateDialog.vue"),
      },
    ],
  },
  {
    path: "/belegjournal",
    name: "ReceiptPage",
    component: () => import("./receipt/ReceiptPage.vue"),
    meta: { requiredRoles: <Permission[]>[FunctionalRole.ReceiptView] },
  },
  {
    path: "/belegjournal/:id",
    name: "ReceiptView",
    component: () => import("./receipt/ReceiptView.vue"),
    meta: { requiredRoles: <Permission[]>[FunctionalRole.ReceiptView] },
    children: [
      {
        path: "",
        name: "ReceiptViewPage",
        component: () => import("./receipt/ReceiptViewPage.vue"),
      },
    ],
  },
]

export default routes
